import axios from 'axios';

export default function setupCSRFToken() {
  const tokenDom = document.querySelector('meta[name=csrf-token]');
  if (tokenDom) {
    const csrfToken = tokenDom.content;
    axios.defaults.headers.common['X-CSRF-Token'] = csrfToken;
  }
}
